module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomerOwnerDataReportTwo"
    }
  }, [_c('div', {
    attrs: {
      "id": "right"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "optionsVal": true,
      "titleName": '入库备案数据',
      "showorg": false
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reportView"
  }, [_c('div', {
    staticClass: "histogram"
  }, [_c('div', {
    ref: "BigThreemyCharts",
    attrs: {
      "id": "BigThreemyCharts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "OnepieChart",
    attrs: {
      "id": "OnepieChart"
    }
  }), _vm._v(" "), _c('div', {
    ref: "Twohistogram",
    attrs: {
      "id": "Twohistogram"
    }
  })])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cbbc494"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportComponentPage/CustomerOwnerDataReportTwo.vue
// module id = 1671
// module chunks = 471